module.exports = __webpack_public_path__ + "img/indeed.29e92524.svg";